import React from 'react';
import { useHistory } from 'react-router-dom';
import {
    makeStyles,
    Grid,
    Paper,
    Dialog,
    AppBar,
    Toolbar,
    Slide,
    IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import Balance from '../../LeaveApplication/component/Balance';
import RecentLeave from '../../LeaveApplication/component/RecentLeave';
import RecentLeaveCollection from '../../Function/RecentLeaveCollection';
import customAxios from '../../API/customAxios';
import Details from '../../MyLeave/component/Details';
import { useIntl } from 'react-intl';
import { checkUndefined } from '../../Function/globalFunction';
import MiniTable from '../../UIComponent/MiniTable';
import CompLeaveCollection from '../../Function/CompLeaveCollection';
import EditCompLeaveForm from '../../CompLeaveRequest/component/Form';
import { Container } from '@mui/material';
import CompLeaveReqsCollection from '../../Function/CompLeaveReqs';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: '#232F3E',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    mainPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
        // maxWidth: '1150px',
    },
    subPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    marginBottom: {
        marginBottom: theme.spacing(2),
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='up' ref={ref} {...props} />;
});

export default function Edit({ handleClose, open, showId, actionPage }) {
    const mode = window.global.editMode;
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [application, setApplication] = React.useState({});
    const [showDetail, setShowDetail] = React.useState(false);
    const [balanceData, setBalanceData] = React.useState([]);
    React.useEffect(() => {
        customAxios.get('/get_my_comp_leave_reqs/' + showId).then((res) => {
            const getCompLeaveReqs = res.data;
            if (getCompLeaveReqs.length > 0 && getCompLeaveReqs[0].action == 'Request') {
                setApplication(getCompLeaveReqs);
                if (getCompLeaveReqs[0].status && String(getCompLeaveReqs[0].status) !== window.global.withdrawn) {
                    setShowDetail(true);
                } else {
                    setShowDetail(false);
                }
                
                setBalanceData(
                    CompLeaveReqsCollection(
                        getCompLeaveReqs[0].comp_leave_balance,
                        intl,
                        'Balance'
                    )
                );
                setShowCompetent(true);
            } else {
                history.push('/home');
            }
        }, error => {
            history.push('/home');
        });
    }, []);

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            PaperProps={{
                style: {
                    backgroundColor: '#f0f2f5',
                    boxShadow: 'none',
                },
            }}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge='start'
                        color='inherit'
                        onClick={handleClose}
                        aria-label='close'
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Container 
                className={classes.container}
                maxWidth='xxl'
            >
                {showCompetent ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={9}>
                            <Paper className={classes.mainPaper}>
                                <EditCompLeaveForm
                                    mode={mode}
                                    application={application}
                                    actionPage={actionPage}
                                    backToTable={handleClose}
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={12} lg={3}>
                            <Paper className={`${classes.subPaper} ${classes.marginBottom}`}>
                                <MiniTable rows={balanceData} staffDuty={application?.staff_duty || application[0]?.staff_duty} />
                            </Paper>
                            {showDetail && (
                                <Paper className={classes.subPaper}>
                                    <Details
                                        handleClose={null}
                                        open={null}
                                        showId={showId}
                                        page='Edit Comp Leave Req'
                                    />
                                </Paper>
                            )}
                        </Grid>
                    </Grid>
                ) : (
                    <div className={classes.circularProgress}>
                        <CircularProgress />
                    </div>
                )}
            </Container>
        </Dialog>
    );
}
